export const env = {
    key: "rzp_test_bWzmWSwgukVYuh"
};
